"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAllWebpFeature = void 0;
exports.isSupportWebp = isSupportWebp;
exports.checkWebpFeature = checkWebpFeature;
exports.checkWebpFeatures = checkWebpFeatures;
/*eslint-disable @typescript-eslint/no-magic-numbers,max-len,jsdoc/check-tag-names */
const ramda_1 = require("ramda");
/**
 * 判断浏览器支持webp
 * @returns {boolean} 是否支持webp
 */
function isSupportWebp() {
    try {
        return document.createElement('canvas').toDataURL('image/webp', 0.5).startsWith('data:image/webp');
    }
    catch (err) {
        return false;
    }
}
const kTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
};
/**
 * 判断是否支持webp
 * @param {keyof typeof kTestImages} feature webp功能
 * @returns {Promise<boolean>} 是否支持webp
 */
async function checkWebpFeature(feature) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
            const result = img.width > 0 && img.height > 0;
            resolve(Boolean(result));
        };
        img.onerror = function () {
            resolve(false);
        };
        img.src = `data:image/webp;base64,${kTestImages[feature]}`;
    });
}
/**
 * 检测是否支持webp功能
 * @param {Array<keyof typeof kTestImages>} [list=keys(kTestImages)] webp 特性功能
 * @returns {Promise<boolean>} 是否支持webp指定功能
 * @export
 */
async function checkWebpFeatures(list = (0, ramda_1.keys)(kTestImages)) {
    const results = await Promise.all(list.map(checkWebpFeature));
    return results.findIndex((r) => r === false) === -1; // eslint-disable-line @typescript-eslint/no-magic-numbers
}
/**
 * 检查是否支持webp全部特性
 * @returns
 */
const checkAllWebpFeature = function () {
    let cache = null;
    return async function () {
        if (cache) {
            return cache;
        }
        cache = checkWebpFeatures();
        return cache;
    };
};
exports.checkAllWebpFeature = checkAllWebpFeature;
//# sourceMappingURL=data:application/json;base64,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